import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a5e40a6")

_pushScopeId("data-v-6a5e40a6")
const _hoisted_1 = { class: "cv" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("I "),
  /*#__PURE__*/_createVNode("em", null, "mainly"),
  /*#__PURE__*/_createTextVNode(" work with these technologies:")
], -1)
const _hoisted_3 = { class: "links" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "And these are the tools that I use more frequently:", -1)
const _hoisted_5 = { class: "links" }
const _hoisted_6 = { class: "hobbies" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("em", null, "I lived through IE6 development. I survived Internet Explorer.", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Through this journey I've picked skills to work on agile environments, lead technical teams and even teach a thing or two. The two principal things that I consider that a project must have are clean code and a clean git repository. ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" On my spare time I collect vinyls, play videogames (currently my heart is with Nintendo Switch), play Magic: the Gathering and binge watch a couple of series at a time. Also, probably polish my cooking skills. ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("ul", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.techLinks, (item) => {
        return (_openBlock(), _createBlock("li", {
          key: item.title
        }, [
          _createVNode("a", {
            href: item.url,
            target: "_blank"
          }, [
            _createVNode("i", {
              class: item.icon
            }, null, 2),
            _createVNode("span", null, _toDisplayString(item.title), 1)
          ], 8, ["href"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _hoisted_4,
    _createVNode("ul", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toolsLinks, (item) => {
        return (_openBlock(), _createBlock("li", {
          key: item.title
        }, [
          _createVNode("a", {
            href: item.url,
            target: "_blank"
          }, [
            _createVNode("i", {
              class: item.icon
            }, null, 2),
            _createVNode("span", null, _toDisplayString(item.title), 1)
          ], 8, ["href"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("p", _hoisted_6, [
      _createTextVNode(" On the technical side, I have a Computer Science degree and I've worked for over " + _toDisplayString(_ctx.total.start) + " years in development, the latest " + _toDisplayString(_ctx.total.front) + " of them focused on Frontend development. ", 1 /* TEXT */),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15
    ])
  ]))
})